// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleRound_container__YVfIm","menuButton":"SingleRound_menuButton__qxaF5"};